import { getNiceDate, isNumber } from '@iotv/datamodel-core';
import { numericAwareStringSortComparator, WrapLinkVOB } from '../../../components/factories/DataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
/** 2024 06 - removed Omit<..., 'field'> as not having field limits resolution of data to column to just order,
 * field was probably Omitted to remove the dependency on viewKeyDefinition having the correct key attribute,
 * If this causes issues,
 */
export const viewDefinitionToGridColumnMap = (viewDefinition, itemsEditable) => {
    const columnMap = {};
    for (const [k, v] of Object.entries(viewDefinition)) {
        if (v.key !== k) {
            debug &&
                console.log(`WARN: ${k} does not match ${v.key}, when converted to GridColDef the field will be set as ${v.key} which may not be correct`, {
                    viewDefinition,
                });
            // v.key = k
        }
        const colDef = viewKeyDefinitionToGridColDef(v, itemsEditable);
        /** removedd from commit f0c0ce4ff3fe851def8cd5acd22b378a7a431530 [ i301 ] Update Mui Data Grid library to v6 as this breaks enum display */
        // if (colDef.type === 'singleSelect' && v.type === AppValueTypes.ENUM && v.enumKV) {
        //   const values = Object.values(v.enumKV)
        //   colDef.valueGetter = () => {
        //     return values;
        //   }
        // }
        columnMap[k] = colDef;
    }
    return columnMap;
};
export const viewKeyDefinitionToGridColDef = (viewKeyDefinition, itemsEditable) => {
    const { label, editable, renderCell } = viewKeyDefinition;
    const colType = getColTypeFromVKDef(viewKeyDefinition);
    const colDef = {
        field: viewKeyDefinition.key,
        headerName: label,
        type: colType,
        valueOptions: colType === 'singleSelect' ? Object.values(viewKeyDefinition.enumKV ?? {}) : undefined,
        sortComparator: ['string', 'singleSelect'].includes(colType) ? numericAwareStringSortComparator : undefined,
        editable: itemsEditable && editable,
        valueGetter: getValueGetterFromVKDef(viewKeyDefinition),
        valueFormatter: getValueFormatterFromVKDef(viewKeyDefinition),
        renderCell,
        flex: 1,
    };
    if (viewKeyDefinition.disableLink) {
        return colDef;
    }
    // if (viewKeyDefinition.link) {
    if (false) {
        // colDef.renderCell = (p) => wrapLinkConstructor(p, viewKeyDefinition.link);
    }
    else if (viewKeyDefinition.key === 'name') {
        const skKey = 'sk';
        if (!(typeof viewKeyDefinition.linkFn === 'function')) {
            colDef.renderCell = colDef.renderCell ?? ((p) => (p.row[skKey] ? WrapLinkVOB(p, skKey, undefined) : p.value));
        }
        else {
            colDef.renderCell = colDef.renderCell ?? ((p) => (p.row[skKey] ? WrapLinkVOB(p, skKey, colDef.renderCell, viewKeyDefinition.linkFn) : p.value));
        }
    }
    return colDef;
};
export const getColTypeFromVKDef = (viewKeyDefinition) => {
    const colType = {
        boolean: 'boolean',
        date: 'date',
        enum: 'singleSelect',
        number: 'number',
        object: undefined,
        string: 'string',
        TIMESTAMP_MS: 'date',
        TIMESTAMP_SEC: 'date',
        TIMESTAMP_STRING_SEC: 'date',
    };
    return colType[viewKeyDefinition.type];
};
/** less problematic functions may potentially reused from ObjectView */
export const getValueGetterFromVKDef = (viewKeyDefinition) => {
    const fromViewDefGetter = viewKeyDefinition.valueGetter
        ? (value, row, column, apiRef) => viewKeyDefinition.valueGetter(value, row)
        : undefined;
    const dateFallBackFn = (value, row, column, apiRef) => {
        debug && console.log(`dateFallBackFn ${viewKeyDefinition.key} has value`, { value, row });
        return value && new Date(value);
    };
    const valueGetter = {
        date: dateFallBackFn,
        TIMESTAMP_MS: dateFallBackFn,
        TIMESTAMP_SEC: dateFallBackFn,
        TIMESTAMP_STRING_SEC: dateFallBackFn,
        enum: (value, row, column, apiRef) => {
            const enumRes = isNumber(value) ? Object.entries(viewKeyDefinition.enumKV ?? { unknownEnum: value }).find(([k, v]) => v === value)?.[0] : value; //?? ( p ) => `EMUM: ${ p }`
            // debug && console.log('Enum valueGetter is', { enumRes, value, row, column,  })
            return enumRes;
        },
    };
    const defaultFn = (value, row, column, apiRef) => value;
    debug && console.log(`getValueGetterFromVKDef DEBUG ${viewKeyDefinition.key}`, { viewKeyDefinition, fn: valueGetter[viewKeyDefinition.type] });
    return fromViewDefGetter ?? valueGetter[viewKeyDefinition.type] ?? defaultFn;
};
export const getValueFormatterFromVKDef = (viewKeyDefinition) => {
    const fromViewDefFn = viewKeyDefinition.valueFormatter
        ? (value, row, column, apiRef) => viewKeyDefinition.valueFormatter(value)
        : undefined;
    // Date types will be auto formatted
    const dateFallBackFn = (value, row, column, apiRef) => getNiceDate(value);
    const valueFormatterMap = {
        date: dateFallBackFn,
        TIMESTAMP_MS: dateFallBackFn,
        TIMESTAMP_SEC: dateFallBackFn,
        TIMESTAMP_STRING_SEC: dateFallBackFn,
        // enum: (value: any, row: any, column: any, apiRef: any)  => {
        //   const enumRes = isNumber(value) ? Object.entries( viewKeyDefinition.enumKV ?? { unknown: value} ).find( ( [k,v]) => v === value)?.[0] : value  //?? ( p ) => `EMUM: ${ p }`
        //   debug && console.log('Enum Res  valueFormatter is', { viewKeyDefinition, value, row, column , })
        //   return enumRes
        // }
    };
    // If we don't find anything, do this
    const fallBackFn = (value, row, column, apiRef) => value;
    debug && console.log(`getValueFormatterFromVKDef DEBUG ${viewKeyDefinition.key}`, { viewKeyDefinition, fn: valueFormatterMap[viewKeyDefinition.type] });
    return fromViewDefFn ?? valueFormatterMap[viewKeyDefinition.type] ?? fallBackFn;
};
